import { useCallback, useEffect } from 'react'
import { LAST_VIEWED_ADVERT_ID } from '@at/window-utils/lib/session-storage-utils/session-storage-keys'
import {
    getItemSessionStorage,
    removeItemSessionStorage,
} from '@at/window-utils/lib/session-storage-utils/session-storage.utils'
import { useSearchPage } from '../forms/hocs/search-page.context'

let lastViewedAdvertId = ''

export const useScrollAdvertIntoView = () => {
    useEffect(() => {
        return () => {
            lastViewedAdvertId = 'unmounted'
        }
    })

    const { queryParams } = useSearchPage()
    const isReturnedFromExpiredAd = queryParams.get('expired-ad')
    return useCallback(
        (elemNode: HTMLDivElement) => {
            if (!lastViewedAdvertId) {
                lastViewedAdvertId = getItemSessionStorage(LAST_VIEWED_ADVERT_ID) || 'not in session storage'
                removeItemSessionStorage(LAST_VIEWED_ADVERT_ID)
            }

            if (elemNode?.id === lastViewedAdvertId && !isReturnedFromExpiredAd) {
                lastViewedAdvertId = 'scrolled'
                elemNode?.scrollIntoView()

                /* mobile back button hack... */
                setTimeout(() => {
                    // for back button to work we need the setTimeout callback
                    // context: we think this is all related to the fact that
                    // every listing component is unmounted and remounted on load
                    // whilst paginating (mobile only)
                    document.getElementById(elemNode?.id)?.scrollIntoView()
                })
            }
        },
        [isReturnedFromExpiredAd]
    )
}
